<template>
  <div class="ic-form__buttons">
    <hr>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" @click="$emit('click')" :disabled="sending">
          <span v-if="!error && !sending">{{$t('label_send_button')}}</span>
          <span v-if="error">{{$t('label_resend_button')}}</span>
          <span v-if="sending">{{$t('label_sending_button')}}</span>
        </button>
        <vue-loading
          v-if="sending"
          type="spin"
          color="#0071BC"
          :size="{ width: '50px', height: '50px' }"
        ></vue-loading>
        <div v-if="error" class="ic-form__error">{{message}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueLoading } from "vue-loading-template";

export default {
  name: "IcFormButtons",
  props: {
    sending: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    }
  },
  components: {
    VueLoading
  }
};
</script>

<style>
.vue-loading {
  display: inline-block;
  margin-left: 10px !important;
  width: 33px !important;
  height: 33px !important;
  vertical-align: middle;
}
.ic-form__error {
  display: inline-block;
  color: #a94442;
  background: #efcacb;
  height: 33px;
  line-height: 33px;
  padding: 0 20px;
}
</style>
